<template>
	<div v-if="filterList.length > 1" class="wf-filter-wrap">
		<div
			v-for="(item, index) in filterList"
			:key="index"
			class="wf-filter-item"
			:class="{
				'wf-filter-item--active': filterValue === item.value
			}"
			@click="handleFilterCheck(item.value)"
		>
			<span>{{ item.text }}</span>
		</div>
	</div>
</template>

<script>
export default {
	name: 'AnnouncementFilter'
};
</script>

<script setup>
import { ref, onMounted, onActivated, getCurrentInstance } from 'vue';
import { useStore } from '@/utils/vue-api';
import { irstore } from '@/fetch/interface';
import { getLanguageType } from '@/assets/js/i18n';
import { useCommonData } from '@rebuild/hooks/useCommonData';

const emit = defineEmits(['change']);

const { isChemExpress } = useCommonData();
const store = useStore();
const instance = getCurrentInstance();
const $axios = instance?.proxy?.$axios;

const filterList = ref([]);
const filterValue = ref('');
const isLoaded = ref(false);

const getIrBaseInfo = store.getters.getIrBaseInfo;
const getPageId = store.getters.getPageId;

const loadFilterList = () => {
	// 如果已经加载过，直接使用缓存数据，但重新初始化高亮状态
	if (isLoaded.value && filterList.value.length) {
		filterValue.value = filterList.value[0].value;
		emit('change', {
			value: filterValue.value,
			filterList: filterList.value
		});
		return Promise.resolve();
	}

	return $axios
		.get(
			irstore.getModulesTabList(getIrBaseInfo.id, getPageId, 'announcement'),
			{
				languageType: getLanguageType()
			},
			{ hideMessage: true }
		)
		.then(res => {
			filterList.value = (res.data || [])
				.sort((a, b) => a.sort - b.sort)
				.filter(v => v.isPublish)
				.map(v => {
					const composeValues =
						v.id != 'announcement_all'
							? [v.id, ...(v.subTabList || []).map(sub => sub.id)]
									.map(v => v.slice(11).replace(/,/g, '#'))
									.join(',')
							: '';
					return {
						text: v.name,
						value: composeValues
					};
				});
			// 皓元医药定制化，添加ESG选项
			if (isChemExpress.value) {
				filterList.value = [...filterList.value, { text: 'ESG', value: 'ESG' }];
			}

			if (filterList.value.length) {
				filterValue.value = filterList.value[0].value;
				isLoaded.value = true;
				emit('change', {
					value: filterValue.value,
					filterList: filterList.value
				});
			}
		});
};

const handleFilterCheck = value => {
	// 正反选
	if (filterValue.value === value) {
		filterValue.value = '';
	} else {
		filterValue.value = value;
	}
	emit('change', {
		value: filterValue.value === 'all' ? '' : filterValue.value,
		filterList: filterList.value
	});
};

onActivated(() => {
	loadFilterList();
});
</script>

<style lang="less" scoped>
.wf-filter-wrap {
	margin-top: -0.1rem;
	padding: 0.16rem 0 0.16rem 0.12rem;
	display: flex;
	flex-wrap: wrap;

	.wf-filter-item {
		flex-shrink: 0;
		margin: 0.1rem 0.08rem 0 0;
		padding: 0 0.15rem;
		height: 0.27rem;
		background: #f5f5f5;
		border-radius: 0.02rem;

		span {
			font-family: 'PingFang SC';
			font-size: 0.13rem;
			line-height: 0.27rem;
			text-align: center;
		}
		&--active {
			font-weight: 550;
			color: #f76a2b;
		}
	}
}
</style>
